export default __webpack_public_path__ + "static/media/horses.10e46d30.png";